<template>
    <div class="card-select-feature" v-if="(plan.selectFeatures || []).length > 0">
        <a-select v-model="cloneSelectedFeatureIndex">
            <a-select-option v-for="(selectFeature, index) of plan.selectFeatures" :value="index" :key="index" :disabled="selectFeature.isDisabled">
                {{ getOptionText(selectFeature.count) }}
            </a-select-option>
        </a-select>
    </div>
</template>
<script>
export default {
    type: "CardSelectFeature",
    props: {
        period: {
            type: String,
            required: true,
        },
        plan: {
            type: Object,
            required: true,
        },
        selectedFeatureIndex: {
            type: Number,
            default: 0,
        },
    },
    data: () => ({
        cloneSelectedFeatureIndex: 0,
    }),
    mounted() {
        this.cloneSelectedFeatureIndex = this.selectedFeatureIndex;
    },
    methods: {
        calculateCount(count) {
            const calc = {
                monthly: {
                    automation: (count * 1),
                    supsis: (count * 1),
                    chatbot: (count * 1),
                    mail: (count * 1),
                    web: (count * 1),
                    "voice-agent": (count * 1),
                },
                "monthly-3": {
                    automation: (count * 3),
                    supsis: (count * 1),
                    chatbot: (count * 3),
                    mail: (count * 1),
                    web: (count * 1),
                    "voice-agent": (count * 1),
                },
                "monthly-6": {
                    automation: (count * 6),
                    supsis: (count * 1),
                    chatbot: (count * 6),
                    mail: (count * 1),
                    web: (count * 1),
                    "voice-agent": (count * 1),
                },
                annual: {
                    automation: (count * 12),
                    supsis: (count * 1),
                    chatbot: (count * 12),
                    mail: (count * 1),
                    web: (count * 1),
                    "voice-agent": (count * 1),
                },
                "annual-2": {
                    automation: (count * 24),
                    supsis: (count * 1),
                    chatbot: (count * 24),
                    mail: (count * 1),
                    web: (count * 1),
                    "voice-agent": (count * 1),
                },
            };
            return calc[this.period][this.plan.type];
        },
        getOptionText(count) {
            const messages = {
                automation: "Tasks",
                supsis: "Agent",
                chatbot: "Chatbot",
                mail: "Mails",
                "web": "Web Traffic",
                "voice-agent": "Voice Agent",
            };
            const period = {
                monthly: "per Month",
                "monthly-3": "per 3 Months",
                "monthly-6": "per 6 Months",
                annual: "per Year",
                "annual-2": "per 2 Years",
            };
            return this.calculateCount(count) + " " + messages[this.plan.type] + " " + period[this.period];
        },
    },
    watch: {
        selectedFeatureIndex(val) {
            if(val === this.cloneSelectedFeatureIndex) return;
            this.cloneSelectedFeatureIndex = val;
        },
        cloneSelectedFeatureIndex(val) {
            if(val === this.selectedFeatureIndex) return;
            this.$emit("selectedFeature", val);
        },
    },
};
</script>
<style lang="scss">
.card-select-feature {
    width: 100%;

    .ant-select {
        width: 100%;
    }

    .ant-select-selection {
        border: 1px solid #22272d !important;
        background: white !important;
        border-radius: 3px !important;
        padding: 4px 4px;
    }
}
</style>
